export enum SuccessMessages {
  ADD_BEER_STYLE = 'Beer style added successfully',
  EDIT_BEER_STYLE = 'Beer style updated successfully',
  UPDATE_USER_INFO = 'User information updated successfully',
  CREATE_BREWERY = 'Brewery created successfully',
  INVITE_PAGE_EDITOR = 'Page editor invited successfully',
  DELETE_EDITOR = 'Editor deactivated successfully',
  UPDATE_EDITOR = 'Editor updated successfully',
  CREATE_PUB = 'Pub created successfully',
  PASSWORD_CHANGE = 'Password changed successfully',
  UPDATE_USER = 'User updated successfully',
  BREWERY_UPDATE = 'Brewery updated successfully',
  PUB_UPDATE = 'Pub updated successfully',
}
